<template>
   <div class="co-chers" >
        <div class="_1200">
          <div class="white-box inf" :style="'color:'+landingPage.textColor">
            <div class="light-logo" :style="`background-image: url('${value.backgroundImage.imageURL}');`"></div>
            <div class="info-title">
            <h2 class="sec-head side headerFont" :style="'color:'+landingPage.textColor">
              {{value.title}}
            </h2>
            <div class="bodyFont" style="text-align: left;" v-html="value.secondColumn"/>
            <br>
            </div>
            <div v-if="value" class="info-desc bodyFont" v-html="value.description"/>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name:"Info-Box",
  props: {
    value: Object,
    landingPage: Object
  },  
}
</script>

<style scoped>
.info-title{
  width: 23%;
}
.info-desc{
  width:70%;
  line-height: 1.85;
  text-align:left
}
</style>